export const GAME_HISTORY = 'game-history';

export const GAME_HISTORY_DEFAULT_FIELDS = [
    'code',
    'datetime',
    'gameName',
    'playerStartBalance',
    'playerEndBalance',
    'bet',
    'win',
    'infoLink',
    'sportsbookGamingDetails',
    'gameSessionCode',
    'playerName',
    'gameSessionStart',
    'aamsCode'
];

export const GAME_HISTORY_INVISIBLE_FIELDS = [
    'datetime',
    'win',
    'gameName',
    'gameSessionCode',
    'playerName',
    'gameSessionStart'
];

export const CELL_TYPE = {
    MONEY: 'money',
    DATE: 'date',
    BOOLEAN: 'boolean',
    LINK: 'link',
    TEXT: 'text',
    TICKET: 'ticket'
};

export const CELL_TYPE_MAPPING = {
    datetime: CELL_TYPE.DATE,
    gameSessionStart: CELL_TYPE.DATE,
    gameSessionEnd: CELL_TYPE.DATE,
    playerStartBalance: CELL_TYPE.MONEY,
    playerEndBalance: CELL_TYPE.MONEY,
    bet: CELL_TYPE.MONEY,
    win: CELL_TYPE.MONEY,
    jackpotBet: CELL_TYPE.MONEY,
    jackpotWin: CELL_TYPE.MONEY,
    autoplay: CELL_TYPE.BOOLEAN,
    infoLink: CELL_TYPE.LINK,
    startTableBalance: CELL_TYPE.MONEY,
    endTableBalance: CELL_TYPE.MONEY,
    isFunBonus: CELL_TYPE.BOOLEAN,
    sportsbookGamingDetails: CELL_TYPE.TICKET
};

export const ONE_MONTH_VALUE = 1;
export const THREE_MONTHS_VALUE = 3;
export const SIX_MONTHS_VALUE = 6;

export const LAST_24_HOURS_VALUE = 1;
export const LAST_WEEK_VALUE = 7;
export const LAST_MONTH_VALUE = 30;
export const LAST_THREE_MONTHS_VALUE = 90;
export const LAST_SIX_MONTHS_VALUE = 180;
export const ANOTHER_PERIOD_VALUE = -1;

export const MAX_PERIOD_DAYS = 180;

export const PERIODS = [
    { label: 'filter.periods.day', value: LAST_24_HOURS_VALUE },
    { label: 'filter.periods.week', value: LAST_WEEK_VALUE },
    { label: 'filter.periods.month', value: LAST_MONTH_VALUE },
    { label: 'filter.periods.threeMonths', value: LAST_THREE_MONTHS_VALUE },
    { label: 'filter.periods.sixMonths', value: LAST_SIX_MONTHS_VALUE }
];

export const PRODUCTS = {
    SPORTSBOOK: 'SPORTSBOOK',
    CASINO: 'CASINO'
};

export const GAMES_SOURCES = {
    COMPLETED_GAMES: 'COMPLETED_GAMES',
    OPEN_GAMES: 'OPEN_GAMES'
};

export const MAX_EXPORT = 500;
